import { Link } from "react-router-dom";

import routes from "@/routes";

import MoneyField from "./MoneyField";
import MomentField from "./MomentField";
import DateField from "./DateField";
import MonthField from "./MonthField";
import FileField from "./FileField";
import PolygonField from "./PolygonField";
import PointField from "./PointField";
import RPointField from "./RPointField";
import TableField from "./TableField";
import EmployeeField from "./EmployeeField";
import ExpandableText from "./ExpandableText";

import { getFullName } from "@/utils";

import {
  DEFINITIONS,
  UPLOAD_FIELDS,
  NUMBER_FIELDS,
  DATE_FIELDS,
} from "@/constants/definitions";

const ObjectFieldValue = ({
  value,
  field,
  miniature = false,
  unit_uuid,
  isAnchor = false,
  notLink = false,
  isAdmins = false,
  onScreenshot,
  color,
  onRefresh,
  onRelatedTasksRefresh,
  object_uuid,
  object_name,
  definition_uuid,
  object_unit_uuid,
  canEditObject,
  isSubObject = true,
  units = [],
}) => {
  // Скролл до нужного раздела страницы
  const scrollTo = (elementId) => {
    const targetElement = document.getElementById(elementId);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  switch (true) {
    case field.type === "money":
      return <MoneyField value={value} />;
    case field.type === "moment":
      return <MomentField value={value} />;
    case field.type === "date":
      return <DateField value={value} />;
    case field.type === "month":
      return <MonthField value={value} />;
    case field.type === "point":
      return (
        <PointField
          value={value}
          miniature={miniature}
          onScreenshot={onScreenshot}
          color={color}
        />
      );
    case field.type === "polygon":
      return (
        <PolygonField
          value={value}
          miniature={miniature}
          onScreenshot={onScreenshot}
          color={color}
        />
      );
    case field.type === "parent_polygon":
      return (
        <PolygonField
          value={value}
          miniature={miniature}
          onScreenshot={onScreenshot}
          color={color}
        />
      );
    case field.type === "rpoint":
      return <RPointField value={value} miniature={miniature} />;
    case field.type === "employee":
      // Якорная ссылка
      if (isAnchor) {
        return notLink ? (
          <div>
            {value
              ? getFullName(value.lastname, value.firstname, value.patronymic)
              : ""}
          </div>
        ) : (
          <a
            href={`#${field?.uuid}`}
            onClick={(e) => {
              e.preventDefault();
              scrollTo(field?.uuid);
            }}
            className="blue-link"
          >
            {value
              ? getFullName(value.lastname, value.firstname, value.patronymic)
              : ""}
          </a>
        );
      }

      return <EmployeeField value={value} />;
    case UPLOAD_FIELDS.includes(field.type):
      return (
        <FileField
          value={value}
          miniature={miniature}
          hideBtn={notLink}
          btnClick={
            isAnchor
              ? (e) => {
                  e.preventDefault();
                  scrollTo(value?.uuid);
                }
              : null
          }
        />
      );

    case DEFINITIONS.includes(field.type): {
      // Якорная ссылка только для объектов и справочников
      if (isAnchor) {
        return ["repository", "object"].includes(field.type) &&
          isSubObject &&
          !notLink ? (
          <a
            href={`#${value?.uuid}`}
            onClick={(e) => {
              e.preventDefault();
              scrollTo(value?.uuid);
            }}
            className="blue-link"
          >
            {value?.name}
          </a>
        ) : (
          <div>{value?.name}</div>
        );
      }
      // Ссылка для репозиториев, таблиц и объектов (которые доступны)
      return !notLink &&
        (["repository", "table"].includes(field.type) ||
          (field.type === "object" && (isAdmins || value?.canView))) ? (
        <Link
          to={
            unit_uuid
              ? routes.unitObjectDetail(unit_uuid, field.object, value?.uuid)
              : isAdmins
                ? routes.administration.objectDetail(field.object, value?.uuid)
                : routes.objectDetail(field.object, value?.uuid)
          }
          onClick={(event) => event.stopPropagation()}
        >
          {value?.name}
        </Link>
      ) : (
        <div>{value?.name}</div>
      );
    }

    case field.type === "text" || field.type === "mask":
      return <ExpandableText value={value} />;
    case [...NUMBER_FIELDS, ...DATE_FIELDS].includes(field.type):
      return <div>{value}</div>;
    case field.type === "table":
      return (
        <TableField
          title={field.name}
          value={value}
          object_uuid={object_uuid}
          object_name={object_name}
          definition_uuid={definition_uuid}
          isAdmins={isAdmins}
          onRefresh={onRefresh}
          onRelatedTasksRefresh={onRelatedTasksRefresh}
          unit_uuid={unit_uuid}
          parent_field={field}
          object_unit_uuid={object_unit_uuid}
          canEditObject={canEditObject}
          units={units}
        />
      );

    default:
      return "";
  }
};
export default ObjectFieldValue;
